import { IS_LOADING } from "lib/graphql/return-is-loading-on-each-request"
import { withInitialValue } from "lib/graphql/with-initial-value"
import { getMaintenanceTasks } from "routes/component-library/controller/maintenance-library"
import { AuthoringHomeStatTile } from "../authoring-home-stat-tile"

export function AuthoringHomeComponentsTile() {
    // query: {} is truthy so the early-return guard is bypassed; take: 1 minimises data transfer
    const result = getMaintenanceTasks.useResults({ query: {}, take: 1 }, withInitialValue(IS_LOADING))
    const count = result === IS_LOADING ? IS_LOADING : result?.totalCount ?? 0

    return (
        <AuthoringHomeStatTile
            title="Component"
            count={count}
            icon="mdi:puzzle-outline"
            palette="info"
            to="/authoring/component-library"
        />
    )
}
